import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import "@cloudscape-design/global-styles/index.css";


const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <div style={{
      backgroundColor: '#0f1b2a',  // Dark blue background
      minHeight: '100vh',  // This ensures full height
      width: '100%',
      position: 'absolute',  // This helps ensure full coverage
      top: 0,
      left: 0,
      right: 0,
      bottom: 0
    }}>
      <App />
    </div>
  </React.StrictMode>
);


